import { TParticipant } from "../types/app.types";

export function isEmptyParticipant(participant: TParticipant) {
  return  !((participant.email && participant.email !== "") &&
          (participant.firstName && participant.firstName !== "") &&
          (participant.lastName && participant.lastName !== ""));
}
